import angular from "angular";
import core from "../../core/core.module";

let mod = angular
    .module('OptionForm', [core])
    .component('optionForm', {
        template: require('./option-form.html'),
        controller: ['Data', '$http', 'notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(Data, $http, notifier) {

    let $ctrl = this;

    $ctrl.optionId = null;
    $ctrl.routes = [];

    $ctrl.$onInit = function () {

        $ctrl.direction = $ctrl.resolve.direction;

        if ($ctrl.resolve.option) {
            $ctrl.optionId = $ctrl.resolve.option.id;
            $ctrl.resolve.option.routes.forEach(function (route) {
                $ctrl.routes.push({
                    depStation: {
                        code: route.dep_station.StationCode,
                        name: route.dep_station.StationNameFull
                    },
                    arrStation: {
                        code: route.arr_station.StationCode,
                        name: route.arr_station.StationNameFull
                    },
                    minTransferMinutes: route.min_transfer_minutes,
                    maxTransferMinutes: route.max_transfer_minutes,
                })
            });
        } else {
            $ctrl.addRoute();
        }
    };

    $ctrl.addRoute = function () {
        $ctrl.routes.push({
            depStation: null,
            arrStation: null,
            minTransferMinutes: null,
            maxTransferMinutes: null,
        })
    };

    $ctrl.searchStations = function (fragment) {
        return Data.getStations(fragment);
    };

    $ctrl.delRoute = function (ind) {
        $ctrl.routes.splice(ind, 1);
    };

    $ctrl.submit = function () {

        let defer;

        let params = {
            routes: $ctrl.routes
        };

        if ($ctrl.optionId) {
            params['_method'] = 'PUT';
            defer = $http.post(`/control-panel/directions/${$ctrl.direction.id}/options/${$ctrl.optionId}`, params);
        } else {
            defer = $http.post(`/control-panel/directions/${$ctrl.direction.id}/options`, params);
        }

        defer.then(
            function (response) {
                let r = [];
                $ctrl.routes.forEach(function (route) {
                    r.push({
                        dep_station: {
                            StationNameFull: route.depStation.name,
                            StationCode: route.depStation.code
                        },
                        arr_station: {
                            StationNameFull: route.arrStation.name,
                            StationCode: route.arrStation.code
                        },
                        min_transfer_minutes: route.minTransferMinutes,
                        max_transfer_minutes: route.maxTransferMinutes,
                    });
                });
                $ctrl.close({
                    $value: {
                        id: $ctrl.optionId || response.data.id,
                        routes: r
                    }
                });
            },
            function (error) {
                notifier.errorResponseNotify(error);
            }
        );
    };
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/direction-options-control/option-form/option-form.js